
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('award-ribbon-star-2')]),_c('path',{attrs:{"d":"M12.531,5.042,13.78,7.5h2.126a.582.582,0,0,1,.419,1l-1.952,1.922L15.455,12.9a.59.59,0,0,1-.84.737L12,12.169,9.385,13.64a.589.589,0,0,1-.839-.737l1.082-2.485L7.675,8.5a.582.582,0,0,1,.42-1h2.126L11.47,5.042A.6.6,0,0,1,12.531,5.042Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('polyline',{attrs:{"points":"4.717 13.152 0.75 18 4.5 18.75 6 23.25 9.991 16.918","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('polyline',{attrs:{"points":"19.283 13.152 23.25 18 19.5 18.75 18 23.25 14.01 16.918","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M12.471.916,14.318,2.4l2.369-.118a.75.75,0,0,1,.761.553l.62,2.29,1.986,1.3a.752.752,0,0,1,.291.9L19.5,9.537l.845,2.216a.751.751,0,0,1-.291.895l-1.986,1.3-.62,2.29a.75.75,0,0,1-.761.553l-2.369-.118-1.847,1.488a.751.751,0,0,1-.941,0L9.683,16.67l-2.369.118a.751.751,0,0,1-.762-.553l-.619-2.29-1.986-1.3a.748.748,0,0,1-.291-.895L4.5,9.537,3.656,7.32a.749.749,0,0,1,.291-.9l1.986-1.3.619-2.29a.751.751,0,0,1,.762-.553L9.683,2.4,11.53.916A.751.751,0,0,1,12.471.916Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    